import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { ReactElement } from 'react'

export default function FourOhFour() {
  const { t } = useTranslation()

  return (
    <div className="flex items-center py-14">
      <div className="container flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
        <div className="max-w-md">
          <div className="text-5xl font-dark font-bold">404</div>
          <p className="text-2xl md:text-3xl font-light leading-normal">
            {t("Sorry we couldn't find this page.")}
          </p>
          <p className="mb-8">
            {t(
              'But dont worry, you can find plenty of other things on our homepage.'
            )}
          </p>

          <Link href="https://www.aloesuite.com" shallow>
            Back to home
          </Link>
        </div>
      </div>
    </div>
  )
}

FourOhFour.getLayout = function getLayout(page: ReactElement) {
  return page
}

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  }
}
